import React, { useEffect, useState } from 'react';
import { routeConfig } from '../../shared/common/constant';
import { useStore } from '../../shared/hooks/stateStore';
import { convertNumTOWords } from '../../shared/hooks/wordNumb';
import PdfViwerComponent from './performaInvoicePdf';
import { Skeleton } from 'antd';
import { useHistory, useParams } from "react-router-dom";

let proformaData: any;
const ProformaInvoicePdfViewer = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const { proformaId } = useParams<any>();
  const history = useHistory();
  useEffect(() => {
    if (proformaId) {
      proformaData = useStore.getState().pfiData;

      if (!proformaData) {
        history.push(routeConfig.proformaList.path)
      } else {
        fetch('https://openexchangerates.org/api/currencies.json')
          .then(response => response.json())
          .then(data => Object.entries(data).forEach(([key, value]) => {
            if (key === proformaData.currency) {
              proformaData.currencyvalue = value;
              proformaData.amountInWords = convertNumTOWords(proformaData.totalAmount, proformaData.currencyvalue);
              setLoading(false);
            }
          }))
      }
    }
  }, []);

  return (
    <>
      {
        loading ? <Skeleton active /> :
          <PdfViwerComponent proformaData={proformaData} />
      }
    </>
  );
}
export default ProformaInvoicePdfViewer